import { JSX, ReactNode } from "react";

import Grid from "@mui/material/Grid";

export type ButtonGroupProps = {
	children: ReactNode;
};

export default function ButtonGroup(
	props: Readonly<ButtonGroupProps>
): JSX.Element {
	return (
		<Grid
			container
			alignItems="center"
			sx={{
				width: "fit-content",
				border: 1,
				borderColor: "divider",
				borderRadius: 1,
				backgroundColor: "background.paper",
				"& hr": {
					my: 0,
					mx: 0.5
				}
			}}>
			{props.children}
		</Grid>
	);
}
